import font, {scaleFonts} from '@buncha/appStyles/style/font';

import {StyleSheet} from 'react-native';
import {getWidth} from '@buncha/utils/common';

export const styles = StyleSheet.create({
  Container: {
    flexGrow: 1,
    justifyContent: 'space-between',
  },
  rowFlex: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
  },
  nameTypo: {
    ...font.FontSize.fontH5,
    textAlign: 'left',
    alignItems: 'center',
  },
  childTypo: {
    textAlign: 'left',
    flex: 1,
  },
  textStyle: {
    marginTop: 10,
  },
  editQyt: {
    paddingLeft: 10,
    paddingRight: 5,
    lineHeight: scaleFonts(14),
    fontFamily: font.fonts.muliSemiBold,
    textDecorationLine: 'underline',
  },
  jcc: {
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 2,
  },
  buttonStyle: {
    height: 37,
    width: getWidth(87),
    marginBottom: 0,
  },
  flexBox: {flex: 1, alignItems: 'flex-start', marginLeft: 10},
  editQtyBox: {
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 5,
  },
  editQtyContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  divider: {marginVertical: 10},
  buyerContainer: {
    flex: 1,
  },
});
